import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from 'react';
import { MARK_COLORS, MARK_FACETS, MARK_FLAT_PATH, MARK_GRID, MARK_TRANSFORM, MARK_VIEWBOX, markFlatFill } from './mark.js';
/** The Yakoot ruby mark as inline SVG. Never recolour the facets, rotate or outline it. The Y counter is a real cut-out. */
export function YakootMark({ variant = 'color', size = 32, title, className, style }) {
    const id = useId();
    const clipId = `ykt-mark-${id}`;
    const common = {
        width: size,
        height: size,
        viewBox: `0 0 ${MARK_VIEWBOX} ${MARK_VIEWBOX}`,
        role: title ? 'img' : undefined,
        'aria-hidden': title ? undefined : true,
        className,
        style,
    };
    if (variant !== 'color') {
        return (_jsxs("svg", { ...common, children: [title ? _jsx("title", { children: title }) : null, _jsx("g", { transform: MARK_TRANSFORM, children: _jsx("path", { fillRule: "evenodd", fill: markFlatFill(variant), d: MARK_FLAT_PATH }) })] }));
    }
    return (_jsxs("svg", { ...common, children: [title ? _jsx("title", { children: title }) : null, _jsx("defs", { children: _jsx("clipPath", { id: clipId, clipRule: "evenodd", children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: MARK_FLAT_PATH }) }) }), _jsx("g", { transform: MARK_TRANSFORM, children: _jsxs("g", { clipPath: `url(#${clipId})`, children: [_jsx("rect", { width: MARK_GRID, height: MARK_GRID, fill: MARK_COLORS.ruby }), MARK_FACETS.map((f, i) => (_jsx("polygon", { points: f.points, fill: f.fill }, i)))] }) })] }));
}
//# sourceMappingURL=YakootMark.js.map